import React from 'react'

import { ErrorBoundary } from '@scoir/error-reporter'
import { Route, Switch } from 'react-router-dom'

import ReactRouterProvider from 'components/ReactRouterProvider'
import RealtimeMessagingProvider from 'components/RealtimeMessagingProvider'

import AuthRoutes from './AuthRoutes'
import UserStartup from './UserStartup'
import UserTrackingStartup from './UserTrackingStartup'

export const AppStartup = () => {
  return (
    <UserStartup>
      <ReactRouterProvider>
        <UserTrackingStartup>
          <RealtimeMessagingProvider>
            <ErrorBoundary>
              <Switch>
                <Route render={(props) => <AuthRoutes {...props} />} />
              </Switch>
            </ErrorBoundary>
          </RealtimeMessagingProvider>
        </UserTrackingStartup>
      </ReactRouterProvider>
    </UserStartup>
  )
}

export default AppStartup
